import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { configureStore } from './redux/store';
import reportWebVitals from './reportWebVitals';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

const App = React.lazy(() => import(/* webpackChunkName: "App" */ './App'));

Bugsnag.start({
  apiKey: '235d6d24a324bf01fb692585a62b2e4c',
  plugins: [new BugsnagPluginReact()]
});

const ErrorFallback = () => (
  <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '80vh', padding: '20px' }}>
    <div className="card border-danger shadow-sm" style={{ maxWidth: '600px', width: '100%' }}>
      <div className="card-header bg-danger text-white">
        <h4 className="mb-0">Oops, something went wrong</h4>
      </div>
      <div className="card-body">
        <p className="text-muted mb-3">
          An unexpected error occurred while loading this page. Please try reloading.
        </p>
        <button className="btn btn-primary" onClick={() => window.location.reload()}>
          Reload Page
        </button>
      </div>
    </div>
  </div>
);

const ErrorBoundary = Bugsnag.getPlugin('react')
  .createErrorBoundary(React);

const Main = () => {
  return (
    <Provider store={configureStore()}>
      <Suspense fallback={<div className="loading" />}>
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <App />
        </ErrorBoundary>
      </Suspense>
    </Provider>
  );
};

ReactDOM.render(<Main />, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
